import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Button,
    Box,
    Typography
} from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import dayjs from "dayjs";

const VendorComparisonPdfPreview = ({
    open,
    onClose,
    comparisonData,
    purchaseIndentNo
}) => {

    const handleSavePdf = () => {
        const pdf = new jsPDF("l", "mm", "a4");

        pdf.setFontSize(14);
        pdf.text("Vendor Quotation Comparison Report", 14, 15);

        pdf.setFontSize(10);
        pdf.text(`Purchase Indent : ${purchaseIndentNo}`, 14, 22);
        pdf.text(`Generated On : ${dayjs().format("DD-MMM-YYYY")}`, 14, 28);

        const tableRows = [];

        comparisonData.forEach(row => {
            tableRows.push([
                row.material_code,
                row.material_description,
                row.party_name,
                 row.vendor_offered_qty,
                row.quoted_price,
                row.payment_terms,
                row.delivery_date,
                             
                row.selectedQty || 0,
                row.totalScore,
                row.rank
            ]);
        });

        autoTable(pdf, {
            startY: 35,
            head: [[
                "Material Code",
                "Material",
                "Vendor",
                "Offer Qty",
                "Price",
                "Payment Terms",
                "Delivery Date",                          
                "Assigned Qty",
                "Score",
                "Rank"
            ]],
            body: tableRows,
            styles: { fontSize: 8 },
            headStyles: { fillColor: [22, 160, 133] }
        });

        pdf.save(`Vendor_Comparison_${purchaseIndentNo}.pdf`);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
            <DialogTitle>Comparison Report Preview</DialogTitle>

            <DialogContent>
                <Box mb={2}>
                    <Typography variant="subtitle2">
                        Purchase Indent : {purchaseIndentNo}
                    </Typography>
                </Box>

                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Material</TableCell>
                            <TableCell>Vendor</TableCell>
                              <TableCell align="Center">Offer Qty</TableCell>
                            <TableCell align="Center">Price</TableCell>
                          <TableCell align="Center">Payment Terms</TableCell>
                          <TableCell align="Center">Delivery Date</TableCell>
                            <TableCell align="Center">Assigned Qty</TableCell>
                            <TableCell align="Center">Score</TableCell>
                            <TableCell align="Center">Rank</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {comparisonData.map((row, i) => (
                            <TableRow key={i}>
                                <TableCell>{row.material_description}</TableCell>
                                <TableCell>{row.party_name}</TableCell>
                                 <TableCell align="Center">{row.vendor_offered_qty}</TableCell>
                                <TableCell align="Center">{row.quoted_price}</TableCell>
                                <TableCell align="Center">{row.payment_terms}</TableCell>
                                <TableCell align="Center">{row.delivery_date}</TableCell>                                                            
                                <TableCell align="Center">{row.selectedQty || 0}</TableCell>
                                <TableCell align="Center">{row.totalScore}</TableCell>
                                <TableCell align="Center">{row.rank}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <Box mt={3} textAlign="right">
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleSavePdf}
                    >
                        Save as PDF
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default VendorComparisonPdfPreview;
